const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'rent-guarantee';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'settings',
  CHASSIS_EXCEPTION: '',
  DOCUMENT_EXCEPTION: 'document-exception',
};

export const generateFullModuleRoute = (route?: string): string => {
  return route
    ? `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`
    : `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Configuraciones',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-ban',
        route: generateFullModuleRoute(),
        title: 'Excepción de chasis',
        activated: true,
      },
      {
        icon: 'pi pi-id-card',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.DOCUMENT_EXCEPTION),
        title: 'Excepción de documento',
        activated: true,
      },
    ],
  },
];
